import React from "react";

import { Drawer } from "../../components/react/drawer/Drawer";

export interface MainMenuLayoutProps {
	content?: React.ReactNode;
	header?: React.ReactNode;
	open: boolean;
	onClose: () => void;
}

export const MainMenuLayout: React.FC<MainMenuLayoutProps> = React.memo(({ content, header, open, onClose }) => (
	<Drawer onClose={onClose} placement="left" when={open} width={340}>
		<div className="absolute inset-0 flex flex-col items-stretch justify-between overflow-hidden">
			<div className="shrink-0 grow-0 bg-primary-600">{header}</div>

			<div className="min-h-0 grow bg-white">{content}</div>
		</div>
	</Drawer>
));
